import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, Plus, SearchX, Sparkles, UserPlus, Users } from 'lucide-react';
import { Button } from '../ui/Button';
interface StudentsEmptyStateProps {
  variant: 'no-records' | 'no-matches';
  onAddStudent: () => void;
  onClearFilters?: () => void;
}
export function StudentsEmptyState({
  variant,
  onAddStudent,
  onClearFilters
}: StudentsEmptyStateProps) {
  const isSearch = variant === 'no-matches';
  return <div className="flex flex-col items-center justify-center px-6 py-16 text-center" data-id="element-330" data-mp="3q2il4tp1q3bm">
      <div className="relative mb-7 grid h-28 w-28 place-items-center" data-id="element-331" data-mp="3v1bvwecy7g83">
        <div className="absolute inset-0 rounded-3xl brand-gradient-soft blur-xl" data-id="element-332" data-mp="3g9tm4yaomhx6" />
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="glass-strong relative grid h-24 w-24 place-items-center rounded-3xl" data-id="element-333" data-mp="3l8ec84w7zl7w">
          {isSearch ? <SearchX className="h-9 w-9 text-brand" strokeWidth={1.6} data-id="element-334" data-mp="2l71bj65cukij" /> : <FolderOpen className="h-9 w-9 text-brand" strokeWidth={1.6} data-id="element-335" data-mp="2l4ndcofdos6r" />}
        </motion.div>
        {!isSearch && <>
            <motion.span animate={{
          y: [0, -14, 0]
        }} transition={{
          duration: 4.2,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.4
        }} className="glass absolute -right-3 -top-2 grid h-9 w-9 place-items-center rounded-xl text-brand-2" data-id="element-336" data-mp="2u0d65ij5oou6">
              <Users className="h-4 w-4" data-id="element-337" data-mp="2yz7nsh5e07cp" />
            </motion.span>
            <motion.span animate={{
          y: [0, 12, 0]
        }} transition={{
          duration: 5.6,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.8
        }} className="glass absolute -bottom-2 -left-4 grid h-9 w-9 place-items-center rounded-xl text-brand-3" data-id="element-338" data-mp="3cy7b9lh5yg7a">
              <Sparkles className="h-4 w-4" data-id="element-339" data-mp="1ilzm6oriwtjf" />
            </motion.span>
          </>}
      </div>

      <h3 className="text-lg font-semibold tracking-tight text-foreground" data-id="element-340" data-mp="3dnckhcnv85me">
        {isSearch ? 'No records match your filters' : 'Your database is ready and empty'}
      </h3>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground" data-id="element-341" data-mp="3ioidzcpcnwwz">
        {isSearch ? 'Try a different name, class or telephone number — or clear the filters to see every record again.' : 'Nothing has been recorded yet. Add your first student and it will appear here instantly, straight from Firestore.'}
      </p>

      <div className="mt-6 flex flex-col gap-2 sm:flex-row" data-id="element-342" data-mp="5fmefjnvaudz">
        {isSearch && onClearFilters && <Button variant="outline" className="h-10 rounded-xl" onClick={onClearFilters} data-id="element-343" data-mp="a62rh2ns0dzt">
            Clear filters
          </Button>}
        <Button onClick={onAddStudent} className="h-10 rounded-xl brand-gradient px-5 text-white shadow-lg shadow-indigo-500/25 hover:opacity-95" data-id="element-344" data-mp="f55tsfcdg643">
          {isSearch ? <Plus className="mr-2 h-4 w-4" data-id="element-345" data-mp="o76pv8vvcm46" /> : <UserPlus className="mr-2 h-4 w-4" data-id="element-346" data-mp="o411jvv2do9i" />}
          Add student
        </Button>
      </div>
    </div>;
}